module.exports = __webpack_public_path__ + "img/platform-transactional.201fed83.svg";